export const Tabs = [
    'general',
    'financing',
    'logistics',
    'quality',
    'support'
]

const FAQs : {
    question : string,
    answer : string,
    category : string
}[] = [
    {
        question : 'What is APIdrug.com?',
        answer : `
            We are a Global platform for Pharma ingredients sourcing headquartered in Singapore. 
            It is a go to destination for pharma manufacturers and API manufacturers across the globe to streamline their 
            existing sourcing requirements and improving the accessibility and the availability of APIs/pharma ingredients 
            through an integrated tech platform. APIdrug.com has global presence across Singapore/SEA, India, China, MEA, 
            and European markets.
        `,
        category : 'general'
    },
    {
        question : 'How does APIdrug.com help me as a buyer?',
        answer : `
            <div>
                <ul>
                    <li>Best pricing discovery</li>
                    <p> 
                        - Bringing together the entire API & Pharma Ingredients value chain to make it available at the best price. By providing access to a wider seller base, we ensure the best pricing 
                    </p>
                </ul>
                
                <ul>
                    <li>Quality adherence </li>
                    <p> 
                        - The suppliers are verified, reliable and meet world-class quality standards such as FDA, EMA, TGA etc. Accredited global agencies validate sellers, certifications, quality checks and process standards. 
                    </p>
                </ul>
                <ul>
                    <li> Access to financing options  </li>
                    <p> 
                        - We offer supply chain financing options to make procurement easy and convenient. We have global tie ups with banks and NBFCs. 
                    </p>
                </ul>
                <ul>
                    <li> On demand availability  </li>
                    <p> 
                        - Having many manufacturers on the platform, provides consistent access to inventory. 
                    </p>
                </ul>
            </div>
        `,
        category : 'general'
    },
    {
        question : 'Which are the products listed on APIdrug.com?',
        answer : `
            Key Starting Material (KSM) |
            Intermediates |
            APIs |
            Excipients |
            Nutraceuticals 
        `,
        category : 'general'
    },
    {
        question : 'What is the cost of signing up on the platform?',
        answer : 'As an introductory offer, the platform is free for both buyers and sellers to register',
        category : 'general'
    },
    {
        question : 'How does APIdrug.com make money?',
        answer : 'We charge a fee on each transaction done on the platform',
        category : 'general'
    },
    {
        question : 'Does APIdrug.com provide supplier certificates?',
        answer : 'Yes, all the suppliers onboard have their certificated uploaded on the platform. These certificates are verified and authenticated by international certification agencies',
        category : 'quality'
    },
    {
        question : 'Can a trader list his products on the platform?',
        answer : `
            Yes, as a trader you must provide trader-related documents and quality documents from each 
            manufacturer
        `,
        category : 'general'
    },
    {
        question : 'What happens when I place a request for quotation?',
        answer : `
            If all the necessary details about your company and business case are provided on the platform, you should 
            expect to get a commercial offer from the manufacturer within 3-15 business days
        `,
        category : ''
    },
    {
        question : 'What happens once I accept an offer?',
        answer : `
            <h1>
                a. We send you a term sheet confirmation agreement for your signature as your commitment to 
                progress and sign CDA with the manufacturer
            </h1> 
            <h1>
                b. You make a dossier audit, if necessary (Read how APIdrug.com can help)
            </h1> 
            <h1>
                c. Agree on the commercial contract (based on the signed term sheet)
            </h1> 
            <h1>
                d. Agree on the logistics, financial and insurance terms and conditions.
            </h1> 
            <h1>
                e. Ship the product to the buyer based on agreed terms 
            </h1> 
        `,
        category : 'general'
    },
    {
        question : 'How much does it cost to place an order?',
        answer : `
            Placing an order for a buyer is free of any charge
        `,
        category : 'general'
    },
    {
        question : 'What documents do I need to provide to register?',
        answer : `
            <p>- While registering on the platform, we require basic information to ascentain if you are a buyer or a seller.</p>
            <p>- While transacting, we will require the following documents: </p>

            <p> i. For Buyers </p>
            <p style="margin-left : 10px"> 1. Registration certifications  </p>
            <p  style="margin-left : 10px"> 2. Licenses (GMP, USFDA, EMA etc) </p>

            <p> ii. For sellers  </p>
            <p style="margin-left : 10px"> 1. Registration certifications  </p>
            <p  style="margin-left : 10px"> 2. Licenses (GMP, USFDA, EMA etc) </p>
            <p  style="margin-left : 10px"> 3. Manufacturing facility certificates & licenses for a material (API, KSM, etc.)  </p>

            <p> - Seller business/company-related certificates & licenses </p>
        `,
        category : 'general'
    },
    {
        question : 'What are shipping terms?',
        answer : `
            Varies for each transaction. For example, ex-works, FOB or CIF. Fulfillment might be done by the seller or 
            3rd party logistics partner or using APIdrug’s own extensive delivery network
        `,
        category : 'logistics'
    },
    {
        question : 'How should I reach out if I have any further questions?',
        answer : `
            You can email us at support@apidrug.com OR call on +91-8655735634
        `,
        category : 'support'
    },
    {
        question : 'Are there any restrictions on geography?',
        answer : `
            APIdrug.com is a global platform with transactions happening cross border in line with local and international regulations
        `,
        category : 'general'
    },
    {
        question : 'Can APIdrug.com help me with financing options?',
        answer : `
            <h1>
                - Yes, as a platform we have tied up with multiple MNC banks and NBFCs to ensure that you get access to financial instruments such as: 
            </h1> 
            <h1>
                a. Revolving credit
            </h1> 
            <h1>
                b. EMI based finance
            </h1> 
            <h1>
                c. Invoice discounting & supply chain financing
            </h1> 
            <h1>
                c. Invoice discounting & supply chain financing
            </h1> 
            <h1>
                You can email us at support@apidrug.com OR call on +91-8655735634 to discuss further
            </h1> 
        `,
        category : 'financing'
    },
];

export default FAQs;